import {
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'Template',
  components: {},
  props: {},
  data: () => ({
    slotDate: '',
    slotHour: '',
    depotName: '',
  }),
  computed: {
    ...mapGetters('appointment', {
      storeSlotDate: 'getDate',
      storeSlotHour: 'getHour',
      storeDepotId: 'getDepotId',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
    }),
    storeDepotName() {
      const depot = this.garages.find(g => g.depotId === this.storeDepotId);
      return depot !== 'undefined' ? depot.name : '';
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setInitialState: 'SET_INITIALSTATE',
    }),
  },
  created() {
    this.slotDate = this.storeSlotDate;
    this.slotHour = this.storeSlotHour;
    this.depotName = this.storeDepotName;

    this.setInitialState(true);
  },
};
